import React from 'react';
import { ReviewTab } from '../wizard/ReviewTab';

interface StepProps {
  catalogItemId?: string;
  ownerId?: string | null;
  /** Called when the user clicks an "Edit" link to jump back to a step. */
  onNavigateToTab?: (stepId: string) => void;
}

/**
 * Maps ReviewTab's legacy 7-tab numeric index (set by the old
 * UploadObject's tab order) to the redesigned 10-step ids. Each
 * ReviewSection in ReviewTab passes its own tabIndex; this table picks
 * the closest new-flow step. Where a legacy tab spans multiple new
 * steps (e.g. media → getty + describe), we point at the most likely
 * destination given what that section displays.
 */
const TAB_INDEX_TO_STEP_ID: Record<number, string> = {
  0: 'images',     // Images section → Upload Images step
  1: 'describe',   // Description section → Artwork Details step
  2: 'getty',      // Media section (work type, techniques, materials) → Getty Vocab step
  3: 'describe',   // Measurements bundled into Artwork Details step
  4: 'catalog',    // Inventory & Albums (was "Catalog & Keywords") now has its own dedicated step
  5: 'provenance', // Provenance & References → Provenance step
  6: 'additional', // Additional Information (notes/location/value) lives in Private Only
};

/**
 * Wraps ReviewTab and translates each section's "Edit" click from the
 * legacy numeric tabIndex to the redesigned step id. Replaces the
 * previous always-jump-to-describe behavior.
 */
export const ReviewStep: React.FC<StepProps> = ({
  catalogItemId,
  ownerId,
  onNavigateToTab,
}) => (
  <ReviewTab
    catalogItemId={catalogItemId}
    ownerId={ownerId}
    onNavigateToTab={(tabIndex) => {
      const stepId = TAB_INDEX_TO_STEP_ID[tabIndex] ?? 'describe';
      onNavigateToTab?.(stepId);
    }}
  />
);
